module.exports = __webpack_public_path__ + "img/desert-silver.47842797.jpg";